export default function BrandStory() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12" style={{ fontFamily: 'var(--font-heading)' }}>
          品牌故事
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20office%20space%20with%20warm%20lighting%2C%20minimalist%20design%2C%20wooden%20desks%2C%20plants%2C%20team%20collaboration%20area%2C%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20comfortable%20and%20inspiring%20atmosphere%2C%20warm%20orange%20and%20cream%20tones&width=800&height=600&seq=brand-story-2026&orientation=landscape"
              alt="香蕉视频团队办公环境"
              className="w-full rounded-xl object-cover"
              title="香蕉视频团队 - 短视频创作与分享平台"
              loading="lazy"
            />
          </div>

          <div>
            <h3 className="text-xl font-bold text-foreground-950 mb-4">从热爱到使命</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              2020年，一群热爱短视频创作的年轻人聚在一起，他们发现市场上缺少一个真正以创作者为中心的内容平台。于是，香蕉视频诞生了。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              我们的名字"香蕉"象征着快乐、活力和分享——就像香蕉一样，我们希望每个人都能轻松地享受短视频带来的乐趣和灵感。从最初的10人小团队，到如今超过1000人的大家庭，香蕉视频始终坚持"让创作更简单，让表达更自由"的初心。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              我们投入巨资研发智能推荐算法，确保每一位创作者都能获得公平的曝光机会；我们建立了完善的创作者扶持体系，从流量扶持到商业变现，全方位助力创作者成长。
            </p>
            <div className="flex items-center gap-8 mt-6">
              <div className="text-center">
                <p className="text-2xl font-bold text-[oklch(var(--primary-500))]" style={{ fontFamily: 'var(--font-heading)' }}>2020</p>
                <p className="text-xs text-foreground-500 mt-1">创立年份</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-[oklch(var(--primary-500))]" style={{ fontFamily: 'var(--font-heading)' }}>1000+</p>
                <p className="text-xs text-foreground-500 mt-1">团队成员</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-[oklch(var(--primary-500))]" style={{ fontFamily: 'var(--font-heading)' }}>全球</p>
                <p className="text-xs text-foreground-500 mt-1">服务范围</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}